import { render } from "./App.vue?vue&type=template&id=adc75eec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=adc75eec&lang=scss"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__